import { UserManager, WebStorageStateStore } from 'oidc-client-ts'
import config from 'constants/config'

export interface OidcConfig {
  authority: string
  clientId: string
  scope: string
}

const DEFAULT_SCOPE = 'openid email offline_access'

export const getOidcConfig = (): OidcConfig => ({
  authority: config.OIDC_AUTHORITY || '',
  clientId: config.OIDC_CLIENT_ID || '',
  scope: DEFAULT_SCOPE,
})

// svc-auth allowlists this exact URL (exact match, subpaths rejected).
export const oidcRedirectUri = (): string => `${window.location.origin}/oidc-callback`

export const createOidcUserStore = (): WebStorageStateStore =>
  new WebStorageStateStore({ store: window.localStorage })

export const createOidcUserManager = (): UserManager => {
  const oidc = getOidcConfig()

  return new UserManager({
    authority: oidc.authority,
    client_id: oidc.clientId,
    scope: oidc.scope,
    redirect_uri: oidcRedirectUri(),
    post_logout_redirect_uri: window.location.origin,
    userStore: createOidcUserStore(),
    // Library-driven renewal (serialised, retried, raises silentRenewError);
    // userLoaded still fires per renew so the cookie mirror keeps working.
    automaticSilentRenew: true,
    revokeTokensOnSignout: true,
  })
}
